import { _createSlice } from './create.slice';

export const createSlice = _createSlice;

export default createSlice;